import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_KEY = 'chainage-admin-token';

export const getAdminPassword = () => {
  try { return localStorage.getItem(ADMIN_KEY) || ''; } catch (e) { return ''; }
};

export const setAdminPassword = (pw) => {
  try { localStorage.setItem(ADMIN_KEY, pw); } catch (e) { /* ignore */ }
};

export const clearAdminPassword = () => {
  try { localStorage.removeItem(ADMIN_KEY); } catch (e) { /* ignore */ }
};

const adminHeaders = () => ({ headers: { 'X-Admin-Password': getAdminPassword() } });

// Public
export const submitInquiry = (payload) => axios.post(`${API}/inquiries`, payload).then(r => r.data);
export const fetchInsights = () => axios.get(`${API}/insights`).then(r => r.data);
export const fetchInsight = (id) => axios.get(`${API}/insights/${id}`).then(r => r.data);
export const fetchCaseStudies = () => axios.get(`${API}/case-studies`).then(r => r.data);
export const fetchCaseStudy = (id) => axios.get(`${API}/case-studies/${id}`).then(r => r.data);

// Admin
export const verifyAdmin = (pw) => axios.post(`${API}/admin/verify`, {}, { headers: { 'X-Admin-Password': pw } }).then(r => r.data);
export const listInquiries = () => axios.get(`${API}/inquiries`, adminHeaders()).then(r => r.data);
export const deleteInquiry = (id) => axios.delete(`${API}/inquiries/${id}`, adminHeaders()).then(r => r.data);
export const createInsight = (payload) => axios.post(`${API}/insights`, payload, adminHeaders()).then(r => r.data);
export const updateInsight = (id, payload) => axios.put(`${API}/insights/${id}`, payload, adminHeaders()).then(r => r.data);
export const deleteInsight = (id) => axios.delete(`${API}/insights/${id}`, adminHeaders()).then(r => r.data);
